import { Certificado } from '../api/certificado';
import { formatDate } from '../utils/formatters';
import { ShieldCheck, ShieldAlert, ShieldX } from 'lucide-react';

interface Props {
  cert: Certificado;
}

function BadgeSituacao({ cert }: Props) {
  const s = cert.situacao ?? 'indefinido';
  if (s === 'vencido') return <span className="badge-danger">Vencido</span>;
  if (s === 'critico') return <span className="badge-danger">Crítico</span>;
  if (s === 'aviso') return <span className="badge-warning">Proximo do vencimento</span>;
  if (s === 'ok') return <span className="badge-success">Válido</span>;
  return <span className="badge-neutral">{s}</span>;
}

function IconSituacao({ cert }: Props) {
  const s = cert.situacao ?? 'indefinido';
  if (s === 'vencido' || s === 'critico') return <ShieldX className="h-5 w-5 text-danger" />;
  if (s === 'aviso') return <ShieldAlert className="h-5 w-5 text-warning" />;
  return <ShieldCheck className="h-5 w-5 text-success" />;
}

export default function CertificadoCard({ cert }: Props) {
  const validacaoOk = cert.validacao_ok !== false;
  return (
    <div className={`card-surface p-4 ${validacaoOk ? '' : 'border-rose-500/30'}`}>
      <div className="flex items-start gap-3">
        <IconSituacao cert={cert} />
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2 mb-2">
            <span className="font-semibold truncate">{cert.nome_titular || cert.nome_arquivo}</span>
            <BadgeSituacao cert={cert} />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 text-sm text-neutral-700 dark:text-neutral-300">
            <div>
              <span className="text-neutral-500 dark:text-neutral-400">CNPJ: </span>
              {cert.cnpj_subject || '-'}
            </div>
            <div>
              <span className="text-neutral-500 dark:text-neutral-400">Emissão: </span>
              {formatDate(cert.data_emissao)}
            </div>
            <div>
              <span className="text-neutral-500 dark:text-neutral-400">Validade: </span>
              {formatDate(cert.data_validade)}
            </div>
            <div>
              <span className="text-neutral-500 dark:text-neutral-400">Dias restantes: </span>
              {cert.dias_restantes ?? '-'}
            </div>
          </div>
          {cert.thumbprint_sha1 && (
            <div className="mt-2 text-xs text-neutral-500 dark:text-neutral-400 truncate">
              SHA1: {cert.thumbprint_sha1}
            </div>
          )}
          {cert.validacao_mensagem && (
            <div className={`mt-3 rounded-lg border px-3 py-2 text-xs ${
              validacaoOk
                ? 'border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300'
                : 'border-rose-200 bg-rose-50 text-rose-800 dark:border-rose-500/30 dark:bg-rose-500/10 dark:text-rose-300'
            }`}>
              {cert.validacao_mensagem}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
